import React from "react";
import { StyleSheet, css } from "aphrodite";
import iosAppStoreImage from "../../assets/app-ios-appstore.png";
import androidPlayStoreImage from "../../assets/app-android-playstore.png";

interface AppStoreDownloadButtonsProps {
  className?: string;
  buttonClassName?: string;
  badgeHeight?: number;
  showApple?: boolean;
  showGooglePlay?: boolean;
  onAppleClick?: () => void;
  onGooglePlayClick?: () => void;
}

export default function AppStoreDownloadButtons({
  className,
  buttonClassName,
  badgeHeight = 50,
  showApple = true,
  showGooglePlay = true,
  onAppleClick,
  onGooglePlayClick
}: AppStoreDownloadButtonsProps) {
  const badgeStyle = {
    ...styles.storeBadge,
    height: `${badgeHeight}px`
  };

  return (
    <>
      {showApple && (
        <a
          href="https://apps.apple.com/us/app/manatee-me/id1439499732?mt=8"
          target="_blank"
          rel="noopener noreferrer"
          className={`${css(styles.downloadButton)} ${buttonClassName || ""} ${className || ""}`}
          onClick={onAppleClick}
        >
          <img src={iosAppStoreImage} alt="Download on the App Store" className={css(badgeStyle)} />
        </a>
      )}
      {showGooglePlay && (
        <a
          href="https://play.google.com/store/apps/details?id=com.manateeandme.app"
          target="_blank"
          rel="noopener noreferrer"
          className={`${css(styles.downloadButton)} ${buttonClassName || ""} ${className || ""}`}
          onClick={onGooglePlayClick}
        >
          <img src={androidPlayStoreImage} alt="Get it on Google Play" className={css(badgeStyle)} />
        </a>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  downloadButton: {
    textDecoration: "none",
    display: "inline-block",
    transition: "opacity 0.2s ease",
    maxWidth: "100%",
    ":hover": {
      opacity: 0.8
    }
  },
  storeBadge: {
    width: "auto",
    maxWidth: "100%",
    height: "auto",
    objectFit: "contain"
  }
});
